<template>
  <div style="width: 100%; background-color: var(--grey_alpha)">
    <div class="view-content">
      <div class="component-container" id="mygrid">
        <div
          v-bind:class="{
            'box-container-form': task.finished,
            'box-container': !task.finished,
          }"
        >
          <div class="content-container" id="area1">
            <!-- title header -->
            <div class="container-header">
              <p class="method-title">PROFILE WYRAZÓW</p>
              <router-link v-if="task.finished" :to="{ name: 'WordProfiles' }">
                <button
                  class="box-close-btn"
                  @click.prevent="task.finished = false"
                >
                  {{ $t("cross") }}
                </button>
              </router-link>
              <router-link v-if="!task.finished" :to="{ name: 'Home' }">
                <button class="box-close-btn">{{ $t("cross") }}</button>
              </router-link>
            </div>
            <b-form @submit="getTaskId">
              <b-form-group :label="this.$t('wordprofiles.word')">
                <b-form-input
                  class="form-input-default"
                  type="text"
                  :placeholder="this.$t('concordance.word_i')"
                  required
                  v-model="form.orth"
                  oninput="setCustomValidity('')"
                />
              </b-form-group>

              <b-form-group :label="this.$t('wordprofiles.word_part')">
                <b-form-select
                  selected=""
                  required
                  v-model="word_part_of_speech.selected"
                  :options="word_part_of_speech.options"
                />
              </b-form-group>

              <b-container style="padding: 0 !important">
                <b-row>
                  <b-col>
                    <b-form-group :label="this.$t('wordprofiles.left')">
                      <b-form-select
                        class="form-input-select"
                        selected="1"
                        required
                        v-model="form.left_window_size"
                        :options="[0, 1, 2, 3, 4, 5]"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group :label="this.$t('wordprofiles.right')">
                      <b-form-select
                        class="form-input-select"
                        selected="1"
                        required
                        v-model="form.right_window_size"
                        :options="[0, 1, 2, 3, 4, 5]"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-container>
              <b-form-group :label="this.$t('wordprofiles.context')">
                <b-form-select
                  selected=""
                  required
                  v-model="context_part_of_speech.selected"
                  :options="context_part_of_speech.options"
                />
              </b-form-group>
              <b-form-group :label="this.$t('wordprofiles.howmanywords')">
                <b-input-group
                  :prepend="howmanywords.toString()"
                  class="mt-3"
                  style="margin-bottom: 1rem"
                >
                  <b-form-input
                    type="range"
                    min="3"
                    max="20"
                    step="1"
                    v-model="howmanywords"
                    @change="changeWords"
                  />
                </b-input-group>
              </b-form-group>
              <b-form-group :label="this.$t('frequency.stop_list')">
                <multiselect
                  v-model="stop_list_sorted"
                  :options="stop_list_default"
                  :multiple="true"
                  :close-on-select="false"
                  deselect-label="☒"
                  select-label="☐"
                  selected-label="☑"
                  @tag="addTag"
                  :taggable="true"
                  :tag-placeholder="this.$t('add_stop_list_tag')"
                ></multiselect>
              </b-form-group>
              <!-- Action btn -->
              <b-form-group class="filters">
                <input-tag
                  v-show="metadata_filters.length > 0"
                  v-model="filters_tagset"
                  :delete-on-backspace="false"
                  :read-only="true"
                ></input-tag>
                <b-button
                  class="btn-block submit-button button-80"
                  type="submit"
                  variant="primary"
                  v-if="!show.loading"
                >
                  {{ $t("wordprofiles.submit") }}
                </b-button>
                <b-button
                  class="btn-block submit-button button-80"
                  disabled
                  variant="primary"
                  v-if="show.loading"
                >
                  <b-spinner small type="grow" />
                  <span v-if="task.finished">{{ $t("task.loading_data") }}</span
                  ><span v-if="!task.finished">{{
                    $t("task.waiting_for_response")
                  }}</span>
                </b-button>
                <b-button
                  class="filter-button button-20"
                  @click="showFilters"
                  v-show="!show.filters"
                >
                  <i class="fas fa-filter"></i>
                </b-button>
                <b-button
                  class="filter-button button-20"
                  @click="hideFilters"
                  v-show="show.filters"
                >
                  <i class="fas fa-filter"></i>
                </b-button>
              </b-form-group>
              <b-form-group class="filters-grp">
                <TaskFilter
                  :output="setFilters"
                  v-show="show.filters"
                  :visible="hideFilters"
                  category="PROFILE WYRAZÓW"
                ></TaskFilter>
              </b-form-group>
              <b-form-group :label="this.$t('concordance.howmany')">
                <b-input-group
                  :prepend="limit.toString()"
                  class="mt-3"
                  style="margin-bottom: 1rem"
                >
                  <b-form-input
                    type="range"
                    min="10"
                    max="100"
                    step="5"
                    v-model="limit"
                    @change="changeLimit"
                  />
                </b-input-group>
              </b-form-group>
            </b-form>
          </div>
        </div>
        <div class="box-container-result" v-if="task.finished" id="area2">
          <div class="content-container" v-if="!show.loading">
            <b-card class="bv-example-row" v-if="task.finished">
              <b-spinner
                v-if="show.loading"
                style="width: 3rem; height: 3rem"
              />
              <div class="content-pagination" v-if="word_profiles.length > 0">
                <b-button
                  @click="show.chart = !show.chart"
                  type="button"
                  class="btn filter-button btn-secondary"
                  style="float: left"
                >
                  <span v-if="!show.chart">▉▂</span>
                  <span v-if="show.chart">◕</span>
                </b-button>
                <vue-json-to-csv
                  :json-data="json_data"
                  :csv-title="csv_title"
                  :separator="'\t'"
                >
                  <b-button
                    type="button"
                    class="btn filter-button btn-secondary"
                    style="float: right"
                  >
                    {{ $t("download_csv") }}
                  </b-button>
                </vue-json-to-csv>
                <b-pagination
                  :total-rows="word_profiles.length"
                  :per-page="limit"
                  @change="changePage"
                  align="center"
                  v-if="word_profiles.length > 0"
                />
              </div>

              <div
                class="content-list col-5 card-img-left"
                v-if="chart.datasets[0].data.length > 1 && task.finished"
              >
                <bar-chart
                  v-if="show.chart && task.finished"
                  :chart-data="chart"
                  :options="bar_options"
                ></bar-chart>
                <h3 v-if="!show.chart" style="margin: 20px 0">
                  100% = wyświetlone profile
                </h3>
                <pie-chart v-if="!show.chart" :chart-data="chart"></pie-chart>
                <div class="line_bottom" style="margin: 20px 0"></div>

                <h3 v-if="!show.chart" style="margin: 20px 0">
                  100% = wszystkie profile
                </h3>
                <pie-chart
                  v-if="!show.chart && task.finished"
                  :chart-data="chart2"
                  :options="pie_options"
                ></pie-chart>
              </div>
              <div
                class="content-list col-5 card-img-left"
                v-if="!(chart.datasets[0].data.length > 1) && task.finished"
              >
                {{ $t("nodata") }}
              </div>
              <div class="content-list col-7">
                <b-row
                  class="justify-content-md"
                  v-for="item in pages"
                  :key="item.id"
                >
                  <b-col col lg="2" class="line_bottom">{{
                    item.collocate
                  }}</b-col>
                  <b-col col lg="6" class="line_bottom text-left">{{
                    item.matching.split(",").join(", ")
                  }}</b-col>
                  <b-col col lg="2" class="line_bottom">{{
                    item.frequency
                  }}</b-col>
                  <b-col col lg="2" class="line_bottom">{{
                    item.percentage.toFixed(3)
                  }}</b-col>
                </b-row>
              </div>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FadeTransition from "@/components/FadeTransition.vue";
import axios from "axios";
import TaskFilter from "@/components/TaskFilter";
import VueJsonToCsv from "vue-json-to-csv";
import PieChart from "../components/PieChart";
import BarChart from "../components/BarChart";
import InputTag from "vue-input-tag";
import { i18n } from "../translations";
import Multiselect from "vue-multiselect";

function compare(a, b) {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}

export default {
  name: "WordProfiles",
  data() {
    return {
      json_data: [],
      csv_title: "word_profiles",
      form: {
        orth: "Polska",
        left_window_size: 1,
        right_window_size: 1,
      },
      task: {
        id: null,
        status: "",
        result: "",
        finished: false,
      },
      show: {
        loading: false,
        filters: false,
        chart: false,
        chart2: false,
      },
      chart: {},
      chart2: {},
      bar_options: {
        legend: { display: false },
      },
      pie_options: {
        legend: { display: true },
        cutoutPercentage: 0,
      },
      word_profiles: [],
      adjective: false,
      noun: true,
      verb: false,
      adverb: false,
      limit: 50,
      howmanywords: 10,
      skip: 0,
      page: 1,
      stop_list: [],
      stop_list_default: [],
      metadata_filters: [],
    };
  },
  components: {
    TaskFilter,
    axios,
    FadeTransition,
    VueJsonToCsv,
    PieChart,
    BarChart,
    InputTag,
    Multiselect,
  },
  watch: {
    page: function (value) {
      this.page = value;
      this.skip = this.limit * this.page;
    },
    limit: function (value) {
      this.limit = value;
      if (this.page > parseInt(this.word_profiles.length / this.limit) + 1) {
        this.page = parseInt(this.word_profiles.length / this.limit) + 1;
      }
      this.skip = this.limit * this.page;
    },
    adjective: function () {
      if (this.noun === false && this.verb === false && this.adverb === false) {
        if (this.adjective === false) {
          this.adjective = true;
          alert(this.$t("quantity_analysis.alert"));
        }
      }
    },
    noun: function () {
      if (
        this.adjective === false &&
        this.verb === false &&
        this.adverb === false
      ) {
        if (this.noun === false) {
          this.noun = true;
          alert(this.$t("quantity_analysis.alert"));
        }
      }
    },
    verb: function () {
      if (
        this.noun === false &&
        this.adjective === false &&
        this.adverb === false
      ) {
        if (this.verb === false) {
          this.verb = true;
          alert(this.$t("quantity_analysis.alert"));
        }
      }
    },
    adverb: function () {
      if (
        this.noun === false &&
        this.verb === false &&
        this.adjective === false
      ) {
        if (this.adverb === false) {
          this.adverb = true;
          alert(this.$t("quantity_analysis.alert"));
        }
      }
    },
  },
  computed: {
    stop_list_sorted: {
      get: function () {
        return this.stop_list.sort(compare);
      },
      set: function (newVal) {
        this.stop_list = newVal.sort(compare);
      },
    },
    filters_tagset() {
      return this.metadata_filters.map(function (x) {
        return i18n.tc(x.name) + ":" + x.value;
      });
    },
    pages: function () {
      try {
        let result = [];
        for (var i = this.skip - this.limit; i < this.skip; i++) {
          if (typeof this.word_profiles[i] !== "undefined") {
            result.push(this.word_profiles[i]);
          }
        }
        return result;
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");

        console.log(Object.keys(e), e.message);
      }
    },
    word_part_of_speech() {
      return {
        selected: "2",
        options: [
          { value: "1", text: this.$t("verb") },
          { value: "2", text: this.$t("noun") },
          { value: "3", text: this.$t("adverb") },
          { value: "4", text: this.$t("adjective") },
        ],
      };
    },
    context_part_of_speech() {
      return {
        selected: "1",
        options: [
          { value: "1", text: this.$t("verb") },
          { value: "2", text: this.$t("noun") },
          { value: "3", text: this.$t("adverb") },
          { value: "4", text: this.$t("adjective") },
          { value: "0", text: this.$t("all") },
        ],
      };
    },
  },
  methods: {
    setFilters: function (metadata, all) {
      this.metadata_filters = [];
      for (let i = 0; i < all.length; i++) {
        if (
          typeof metadata[all[i]] !== "undefined" &&
          metadata[all[i]] !== ""
        ) {
          this.metadata_filters.push({
            name: all[i],
            value: metadata[all[i]],
          });
        }
      }
      if (
        typeof metadata["publication_year"] !== "undefined" &&
        metadata["publication_year"] !== ""
      ) {
        this.metadata_filters.push({
          name: "publication_year",
          value: metadata["publication_year"],
        });
      }
    },
    showFilters: function () {
      this.show.filters = true;
    },
    hideFilters: function () {
      this.show.filters = false;
    },
    getTaskId: async function (event) {
      event.preventDefault();
      this.task.finished = false;
      this.show.loading = true;
      this.word_profiles = [];
      this.show.chart = false;
      this.json_data = [];
      let stopList = "";
      this.stop_list.forEach((element) => {
        stopList += element + ";";
      });
      let task = {
        task_type: "word_profile",
        metadata_filter: this.metadata_filters,
        query_parameters: [
          {
            name: "orth",
            value: this.form.orth.toString(),
          },
          {
            name: "part_of_speech",
            value: this.word_part_of_speech.selected.toString(),
          },
          {
            name: "window_item_part_of_speech",
            value: this.context_part_of_speech.selected.toString(),
          },
          {
            name: "left_window_size",
            value: this.form.left_window_size.toString(),
          },
          {
            name: "right_window_size",
            value: this.form.right_window_size.toString(),
          },
          {
            name: "stop_list",
            value: stopList,
          },
        ],
        response_parameters: [],
      };

      try {
        let response = await axios.post(
          process.env.ROOT_API + "startTask",
          task,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            crossDomain: true,
            timeout: 5000,
          }
        );
        await this.checkStatus(response.data.id, 200);
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");

        this.task.finished = false;
        this.show.loading = true;
        console.log(Object.keys(e), e.message);
      }
    },
    checkStatus: async function (taskId, timer) {
      try {
        timer += 100;
        let response = await axios.get(
          process.env.ROOT_API + "getStatus/" + taskId,
          {
            timeout: 1000,
          }
        );
        this.task.status = response.data.status;

        if (this.task.status === "DONE") {
          await this.getResult(taskId);
        } else if (this.task.status === "QUEUE") {
          if (timer <= 5000) {
            setTimeout(() => {
              this.checkStatus(taskId, timer);
            }, timer);
          } else {
            this.task.finished = false;
            this.show.loading = false;
          }
        } else if (this.task.status === "ERROR") {
          this.task.finished = false;
          this.show.loading = false;
        }
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");

        console.log(Object.keys(e), e.message);
      }
    },
    getResult: async function (taskId) {
      try {
        this.task.finished = true;
        let response = await axios.get(
          process.env.ROOT_API + "getResult/" + taskId,
          {
            timeout: 5000,
          }
        );

        this.changePage(1);
        this.skip = this.limit;
        this.csv_title =
          "word_profiles_" +
          this.form.orth +
          "_L" +
          this.form.left_window_size +
          "_R" +
          this.form.right_window_size;
        this.word_profiles = response.data.result.rows;
        response.data.result.rows.forEach((x) => {
          this.json_data.push({
            collocate: x.collocate,
            matching: x.matching,
            frequency: x.frequency,
            percentage: x.percentage,
          });
        });
        this.mapChartData(response.data.result.rows);
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");

        console.log(Object.keys(e), e.message);
        this.show.loading = false;
      }
    },
    changePage: function (value) {
      try {
        this.page = value;
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");

        console.log(Object.keys(e), e.message);
      }
    },
    changeLimit: function (value) {
      try {
        this.changePage(1);
        this.limit = value;
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");

        console.log(Object.keys(e), e.message);
      }
    },
    changeWords: function (value) {
      try {
        this.howmanywords = value;
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");

        console.log(Object.keys(e), e.message);
      }
    },
    mapChartData: function (data) {
      this.chart2 = {
        label: "100% = wszystkie modele",
        labels: [],
        datasets: [
          {
            backgroundColor: [
              "#2a7be4",
              "#2b95e4",
              "#2db5e4",
              "#30d6e4",
              "#31e4cf",
              "#2de4b0",
              "#24e482",
              "#20e45a",
              "#1ee437",
              "#0eda0b",
            ],
            data: [],
          },
        ],
      };
      this.chart = {
        label: "100% = wyświetlone modele",
        labels: [],
        datasets: [
          {
            backgroundColor: [
              "#ec4040",
              "#ec407c",
              "#ec40c7",
              "#b040ec",
              "#8840ec",
              "#4b40ec",
              "#405dec",
              "#4085ec",
              "#40a7ec",
              "#40d2ec",
              "#40d2ec",
              "#40a7ec",
              "#4085ec",
              "#405dec",
              "#4b40ec",
              "#8840ec",
              "#b040ec",
              "#ec40c7",
              "#ec407c",
              "#ec4040",
            ],
            data: [],
          },
        ],
      };
      // let left = 100
      let fields =
        data.length >= this.howmanywords ? this.howmanywords : data.length;

      this.chart.labels = [];
      this.chart.datasets[0].data = [];
      this.chart2.labels = [];
      this.chart2.datasets[0].data = [];
      let sum = 0;
      for (let i = 0; i < fields; i++) {
        this.chart.labels[i] = data[i].collocate;
        this.chart.datasets[0].data[i] = data[i].percentage;
        sum += data[i].percentage;
        if (i == fields - 1) {
          this.chart2.labels[i] = data[i].collocate;
          this.chart2.datasets[0].data[i] = data[i].percentage;
          this.chart2.labels[i + 1] = "inne";
          this.chart2.datasets[0].data[i + 1] = 100 - sum;
        } else {
          this.chart2.labels[i] = data[i].collocate;
          this.chart2.datasets[0].data[i] = data[i].percentage;
        }
      }
      this.show.loading = false;
      setTimeout(() => {
        this.show.chart = true;
      }, 5555);
    },
    getStopList: async function () {
      try {
        let task = {
          task_type: "dictionaries",
          metadata_filter: [],
          query_parameters: [
            {
              name: "dictionaries",
              value: "true",
            },
          ],
          response_parameters: [],
        };

        let response = await axios.post(
          process.env.ROOT_API + "startTask",
          task,
          {
            headers: {
              "Content-Type": "application/json",
            },
            crossDomain: true,
            timeout: 5000,
          }
        );
        await this.checkStopListStatus(response.data.id, 100);
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");

        console.log(Object.keys(e), e.message);
      }
    },
    checkStopListStatus: async function (taskId, timer) {
      try {
        timer += 200;
        let response = await axios.get(
          process.env.ROOT_API + "getStatus/" + taskId,
          {
            timeout: 10000,
          }
        );
        if (response.data.status === "DONE") {
          await this.getStopListResult(taskId);
        } else if (response.data.status === "QUEUE") {
          setTimeout(() => {
            this.checkStopListStatus(taskId, timer);
          }, timer);
        }
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");

        console.log(Object.keys(e), e.message);
      }
    },
    getStopListResult: async function (taskId) {
      try {
        let response = await axios.get(
          process.env.ROOT_API + "getResult/" + taskId,
          {
            timeout: 5000,
          }
        );
        this.stop_list_default =
          response.data.result.dictionaries.default_stop_list.sort(compare);
        this.stop_list = response.data.result.dictionaries.default_stop_list;
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");

        console.log(Object.keys(e), e.message);
        this.show.loading = false;
      }
    },
    addTag(newTag) {
      this.stop_list.push(newTag);
    },
  },
  mounted() {
    this.getStopList();
  },
};
</script>
<style scoped>
@media only screen and (min-width: 768px) {
  .card-body {
    overflow-y: auto;
    overflow-x: hidden;
  }
}
@media only screen and (max-width: 768px) {
  #mygrid {
    display: grid;
    grid-template-areas:
      "area1"
      "area2";
  }
  #area1 {
    grid-area: area1;
    position: relative;
    width: 100%;
  }
  #area2 {
    grid-area: area2;
    position: relative;
    width: 100%;
    height: 45vh !important;
  }
  .box-container-form {
    width: 100%;
  }
}
@media only screen and (max-width: 375px) {
  #mygrid {
    display: grid;
    grid-template-areas: "area1" "area2";
  }
  #area1 {
    grid-area: area1;
    position: relative;
    width: 100%;
    height: fit-content;
  }
  #area2 {
    z-index: 99;
    grid-area: area2;
    position: relative;
    width: 100%;
    margin-top: 1rem;
    padding-bottom: 1rem;
  }
  .card-img-left {
    display: none;
  }
  .col-7 {
    max-width: 100% !important;
  }
  #area2 .content-pagination {
    display: flex;
    flex-direction: column;
    height: fit-content;
  }
  .rows-count {
    margin-bottom: 0.2rem;
  }
  .filter-button {
    float: none !important;
  }
  #area2 .content-list {
    font-size: 12px;
  }
}
.line_bottom {
  border-bottom: 1px solid #c3c3c3;
}
.component-container {
  background-color: transparent;
}
.container-header {
  display: flex;
  align-items: flex-start;
  background-color: var(--white_grey);
  align-items: center;
  border-radius: 5px;
  margin-bottom: 8px;
  padding-right: 4px;
}
.method-title {
  display: flex;
  width: 100%;
  font-weight: bold;
  color: var(--grey_black);
  margin: 6px;
  justify-content: center;
}
.box-container {
  height: 90%;
  border-radius: 0;
}
.box-close-btn {
  width: 25px;
  background-color: rgba(255, 255, 255, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
}
#area1 {
  height: 100%;
}
.content-container {
  background-color: rgba(255, 255, 255, 0.5);
  height: 100%;
}
.content-pagination {
  height: 50px;
  background-color: var(--dark_silver);
  padding: 6px;
}
.card.bv-example-row,
.card-body {
  height: 100%;
}
.content-list {
  margin: auto;
  float: left;
  height: calc(100% - 30px);
  overflow-y: auto;
  overflow-x: hidden;
}
.box-container-result {
  overflow: inherit;
}
.filters-grp {
  z-index: 99;
  display: flex;
  width: auto;
  max-width: 500px;
  max-height: 30vh;
  padding-right: 1rem;
  overflow-y: scroll;
}

.text-left {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/WordProfiles.vue